import { Table } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded, withFirebase, withFirestore } from 'react-redux-firebase'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { withHandlers } from 'recompose'
import { compose } from 'redux'

import { Team, TeamId } from '../../schemas/Team'
import { TenantId } from '../../schemas/Tenant'

import { SHOW_NOTIFICATION } from '../../constants/ActionTypes'
import { ERROR, SUCCESS } from '../../constants/notifications'
import { fsCollections, makeInBatchWithFirebase } from '../../helpers/firestore'
import routes from '../../helpers/routes'
import { DeleteButtonWithConfirmation } from '../ActionWithConfirmation'
import { Flag } from '../countries'
import authorize from '../higher-order/authorize'

import './TeamList.css'

type RemoveTeamProps = {
  removeTeamAction(): void
}

const RemoveTeam: React.FunctionComponent<RemoveTeamProps> = ({ removeTeamAction }) => (
  <DeleteButtonWithConfirmation
    title="Are you sure to remove this team?"
    popupPlacement="left"
    onConfirmAction={removeTeamAction}
  />
)

const columnConfig = (tenant: TenantId, removeTeam: (teamId: TeamId) => void) => [
  {
    title: 'Name',
    key: 'name',
    render: (text, record) => <Link to={routes.editTeam(tenant, record.id)}>{record.name}</Link>,
  },
  {
    title: 'Short Name',
    key: 'short',
    render: (text, record) => record.short,
  },
  {
    title: 'Nationality',
    key: 'nationality',
    render: (text, record) => <Flag iso2={record.nationality} showIso3 />,
  },
  {
    key: 'action',
    width: '2em',
    render: (text, record) => {
      const removeTeamAction = () => removeTeam(record.id)

      return !record.main && <RemoveTeam removeTeamAction={removeTeamAction} />
    },
  },
]

type TeamListProps = {
  tenant: TenantId
  globalTeams: Team[]
  removeTeam(teamId: TeamId): void
}

const TeamList: React.FunctionComponent<TeamListProps> = ({ tenant, globalTeams, removeTeam }) => {
  // TODO take from locale/config
  const isLoading = !isLoaded(globalTeams)

  const sortedTeams = globalTeams || [] // TODO sort

  return (
    <div className="GlobalTeams">
      <Table
        dataSource={sortedTeams}
        columns={columnConfig(tenant, removeTeam)}
        rowKey="id"
        loading={isLoading}
        size="small"
        pagination={false}
      />
    </div>
  )
}

export default compose<FIXME>(
  authorize('admin'),
  withFirebase,
  withFirestore,
  withRouter,
  firestoreConnect<FIXME>(({ tenant }) => [{ collection: fsCollections.globalTeams(tenant) }]),
  connect(({ firestore }: FIXME, { tenant }: FIXME) => ({
    globalTeams: firestore.ordered[fsCollections.globalTeams(tenant)],
  })),
  withHandlers({
    deleteSuccess: ({ dispatch, history, tenant }: FIXME) => (leaveEdit) => {
      dispatch({ type: SHOW_NOTIFICATION, message: 'Team deleted', kind: SUCCESS })
      if (leaveEdit) {
        history.push(routes.manageTeams(tenant))
      }
    },
    deleteError: ({ dispatch }) => (err) => {
      // tslint:disable-next-line:no-console
      console.error('Failed to delete team', err)
      dispatch({ type: SHOW_NOTIFICATION, message: 'Failed to delete team', kind: ERROR })
    },
    inBatchBound: makeInBatchWithFirebase,
  }),
  withHandlers({
    removeTeam: ({ inBatchBound, tenant, match, deleteSuccess, deleteError }) => (teamId) =>
      inBatchBound((firestore, batch) => {
        const collection = firestore.collection(fsCollections.globalTeams(tenant))
        batch.delete(collection.doc(teamId))
      })
        .then(() => deleteSuccess(match.url === routes.editTeam(tenant, teamId)))
        .catch(deleteError),
  }),
)(TeamList)



// WEBPACK FOOTER //
// ./src/components/teams/TeamList.tsx